export enum FeeType {
    Buyer = 'buyer',
    Immediate = 'immediate',
    NetTerms = 'net',
}
